import React from 'react';
import { Link } from 'react-router-dom';

const CHANNEL_URL = 'https://www.youtube.com/@quietbambooo';
const watch = (id) => `https://www.youtube.com/watch?v=${id}`;

const post = {
  slug: 'quiet-bamboo-update',
  title: 'Quiet Bamboo: nineteen videos in',
  date: '2026-09-21',
  cover: 'https://i.ytimg.com/vi/xQAbiSCcW04/maxresdefault.jpg',
  coverAlt:
    'A watercolour of a farmer bending over young rice in a flooded paddy, mountains behind',
  excerpt:
    'An update on Quiet Bamboo: 2,200 subscribers, one story past 142,000 views, a steadier rhythm of new videos, and a wider shelf of old wisdom to draw from.',
  content: (
    <>
      <p>
        When we <Link to="/blog/quiet-bamboo">introduced Quiet Bamboo</Link>{' '}
        back in August, the channel was brand new and one video had
        unexpectedly passed 104,000 views. Since then we have kept making
        stories, a new one every few days, and the channel has started to feel like
        a real place rather than an experiment. Here is where things stand.
      </p>

      <h2>The numbers, honestly</h2>
      <p>
        As of this week, Quiet Bamboo has a little over 2,200 subscribers and
        nineteen videos.{' '}
        <a href={watch('d9zFQ8EkEzs')}>You Don&apos;t Have to Be Useful</a>,
        the story of the tree nobody could find a use for, kept going after
        we wrote about it and is now past 142,000 views. It is still the video
        most people find us through.
      </p>
      <p>
        The rest of the catalogue tells a quieter story. Most of the newer
        videos settle somewhere between a few hundred and around 1,600 views.
        We are fine with that. A single breakout does not make a channel.
        What makes a channel is people coming back for the next one, and the
        steady numbers on the smaller videos are the first sign that they
        are.
      </p>

      <h2>What we have been making</h2>
      <p>
        The recent run has leaned into the ideas that seemed to land. Several
        stories are about putting down effort rather than adding more of it:{' '}
        <a href={watch('549_VfQLbzs')}>the Cook Ding story and wu wei</a>,{' '}
        <a href={watch('XBI60ohiGUw')}>You Don&apos;t Have to Force It</a>{' '}
        (currently our second most watched), and{' '}
        <a href={watch('I94oQh5PO1I')}>Lao Tzu&apos;s wisdom about water</a>.
        Others are about identity and starting again:{' '}
        <a href={watch('pzHCcjkPKQg')}>You&apos;re Not Your Labels</a> went up
        a few days ago and is already one of the faster starters, and{' '}
        <a href={watch('llTJIL13Cws')}>
          Look Beyond the Past &amp; Refuse to Let Pain Define You
        </a>{' '}
        is a story about rebuilding from nothing.
      </p>

      <div className="video-embed">
        <iframe
          src="https://www.youtube.com/embed/pzHCcjkPKQg"
          title="You're Not Your Labels: A Daoist Story About Who You Really Are"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      <p>
        The look of the channel has settled too. Every story now comes with
        watercolour and ink illustrations: misty rivers, paddies, a scholar
        asleep by an open window. It is the style we were reaching for from
        the start, and it suits the pace of the narration.
      </p>

      <h2>A wider shelf</h2>
      <p>
        The channel started with Daoist and Confucian parables, and those are
        still the heart of it. But the old Chinese and East Asian traditions
        hold far more calm stories than two schools can supply, so we are
        widening the shelf. Buddhist tales, strategic classics and stories
        from classical literature are all fair game now.
      </p>
      <p>
        The newest video is our first from Mencius.{' '}
        <a href={watch('xQAbiSCcW04')}>Growth Cannot Be Hurried</a> is
        built around one of his best-known images: a farmer
        so impatient for his crop that he tugs at the young shoots to help
        them along. Anyone who has ever tried to rush a project, a recovery or
        a child will recognise the ending.
      </p>

      <div className="video-embed">
        <iframe
          src="https://www.youtube.com/embed/xQAbiSCcW04"
          title="Growth Cannot Be Hurried | Ancient Chinese Wisdom From Mencius"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      <h2>What comes next</h2>
      <p>
        More of the same, which is rather the point. A new story every few
        days, each around ten to fifteen minutes long, each one idea told
        slowly. The comments are still the best part of running the channel,
        and a surprising number are people telling us which story they needed
        that particular day. If
        there is an old tale you think deserves a quiet retelling, leave it
        in the comments and we will add it to the list.
      </p>
      <p>
        If you have not visited yet,{' '}
        <a href={CHANNEL_URL}>subscribe to Quiet Bamboo on YouTube</a> and
        start with whichever title you need most. The mountains will keep.
      </p>
    </>
  ),
};

export default post;
